module.exports = __webpack_public_path__ + "static/media/5.e3db42c6.jpg";